import React from 'react';
import type { Nullable } from 'corgi-types';
import type { EnergyClassScaleType } from 'graphql-ts-types';

import EnergyTag, { type EnergyTagSize } from '../EnergyTag';
import EnergyLabelList from './EnergyLabelList';
import { useEnergyClass } from './hooks';

export interface EnergyClassProps {
  class: string;
  scaleType?: EnergyClassScaleType;
  labelUrls?: Nullable<string[]>;
  href?: string;
  shouldHandleEnergyHash?: boolean;
  size?: EnergyTagSize;
  isDrawerToggleEnabled?: boolean;
}

const EnergyClass = ({
  class: energyClass,
  scaleType,
  href,
  shouldHandleEnergyHash,
  size,
  labelUrls = [],
  isDrawerToggleEnabled = true,
}: EnergyClassProps) => {
  const openDrawer = useEnergyClass({
    content: <EnergyLabelList urls={labelUrls} />,
    labelUrls,
    shouldHandleEnergyHash,
  });
  const shouldOpenDrawer = isDrawerToggleEnabled && !href && labelUrls.length > 0;

  return (
    <EnergyTag
      href={href}
      onClick={shouldOpenDrawer ? openDrawer : null}
      energyClass={energyClass}
      scaleType={scaleType}
      size={size}
    />
  );
};

export default EnergyClass;
